export default "__VITE_ASSET__i5OwT9O$__"